module.exports = __webpack_public_path__ + "static/media/asc-plus.f96bb9c3.svg";